<!--
 * @Author: vince
 * @Date: 2021-08-18 16:04:46
 * @LastEditors: vince
 * @LastEditTime: 2021-09-13 10:11:18
 * @Description:
-->
<template>
  <el-select
    size="small"
    :multiple-limit="multiple ? multipleLimit : 0"
    :multiple="multiple"
    :class="['authorSelector', multiple ? 'multiple' : '']"
    value-key="userId"
    :value="selected"
    :allow-create="allowCreate"
    filterable
    :filter-method="filterMethod"
    placeholder="请选择"
    :loading="loading"
    @change="onChange"
    :options="options"
    clearable
    :disabled="isReadOnly"
  >
    <el-option
      v-for="item in options"
      :key="item.userId"
      :label="item.userName"
      :value="item"
    ></el-option>
  </el-select>
  <!-- <el-select multiple class="authorSelector" value-key="userId" :value="selected" allow-create filterable :filter-method="filterMethod" placeholder="请选择" :loading="loading" @change="onChange" :options="options" clearable>
  		<el-option v-for="item in options" :key="item.userId" :label="item.userName" :value="item"></el-option>
  	</el-select>-->
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { postJson, postData } from "../../http/fetch.js";
export default {
  name: "authorSelector",
  model: {
    prop: "value",
    event: "change"
  },
  data() {
    return {
      selected: null,
      loading: false,
      options: [],
      list: []
    };
  },
  props: {
    multiple: {
      type: Boolean,
      default: true
    },
    allowCreate: {
      type: Boolean,
      default: true
    },
    value: {
      type: Array | Object | String
    },
    schoolCodes: {
      type: String | Array
    },
    isReadOnly:{
      type: Boolean,
      default: false,
    },
    multipleLimit: {
      type: Number,
      default: 10,
    },
  },
  computed: {
    ...mapGetters({ storeSchoolCodes: "schoolCodes", schoolCode: "schoolCode", operatorId: "operatorId" }),
    ...mapState(["userInfo", "schoolList", "isAdmin"]),
    /** 请求用校区列表：props.schoolCodes 为空数组时仍为 truthy，不能原样传给接口 */
    requestSchoolCodes() {
      const p = this.schoolCodes;
      if (Array.isArray(p) && p.length > 0) return p;
      if (p != null && p !== "" && !Array.isArray(p)) return p;
      if (Array.isArray(this.storeSchoolCodes) && this.storeSchoolCodes.length > 0) {
        return this.storeSchoolCodes;
      }
      return this.schoolCode ? [this.schoolCode] : [];
    },
  },
  created() {
    this.selected = this.value;
    this.getTeacherInfoList();
  },
  watch: {
    value(v) {
      this.selected = v;
    },
    schoolCodes: {
      deep: true,
      handler() {
        this.getTeacherInfoList();
      },
    },
  },
  methods: {
    onChange(v) {
      this.selected = v;
      this.$emit("change", v);
    },
    async getTeacherInfoList(query='') {
      this.loading = true;
      return new Promise((resove, reject) => {
        postJson("/user/getTeacherInfoList", {
          schoolCodes: this.requestSchoolCodes,
          keyword:query
        })
          .then(res => {
            const rows = res && Array.isArray(res.records) ? res.records : [];
            if (rows.length) {
              // if (this.isAdmin) {
                // this.list = res.records;
                this.options = rows;
              // } else {
              //   this.list = [
              //     {
              //       userId: this.userInfo.userId,
              //       userName: this.userInfo.userName
              //     }
              //   ];
              //   this.options = [
              //     {
              //       userId: this.userInfo.userId,
              //       userName: this.userInfo.userName
              //     }
              //   ];
              // }
              resove(this.options);
            } else {
              reject();
            }
          })
          .catch(e => {
            reject(e);
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    async filterMethod(query) {
      if (this.options.length == 0) {
        await this.getTeacherInfoList();
      }else{
        await this.getTeacherInfoList(query);
      }
      // if (query !== "") {
        //  await this.getTeacherInfoList(query);
        // this.options = this.list.filter(f => {
        //   return (
        //     f.userName &&
        //     f.userName.toLowerCase().indexOf(query.toLowerCase()) > -1
        //   );
        // });
      // } else {
      //   this.options = this.list;
      // }
    },
  },
};
</script>

<style lang='less' scoped>
.authorSelector {
  display: block;

}

.multiple {
  .el-input {
    width: 500px;
  }
}
</style>
